import { BasketOrderPrices } from '@/services/basket'
import { Spinner } from './spinner'
import { usePrice } from './price'
import { useAppContext } from '@/pages/_app'

export type OrderDeliveryPriceProps = {
  orderPrices: BasketOrderPrices
  orderIsPaid: boolean
  showNextTier: boolean
}

export function OrderDeliveryPrice(props: OrderDeliveryPriceProps) {
  const { t } = useAppContext()
  const price = usePrice()
  return (
    <div className="px-4 custom-delivery-price-block">
      <div style={{ minHeight: `${7 / 4}rem` }} className="flex justify-between text-lg">
        <div>
          <span>
            {props.orderPrices !== 'loading' && props.orderPrices.delivery?.priceDependsOnTaxi
              ? t('common:deliveryPriceDependsOnTaxi')
              : t('orderDeliveryPrice:delivery')}
          </span>
          {(() => {
            if (
              props.orderPrices === 'loading' ||
              !props.orderPrices.delivery ||
              !props.showNextTier
            ) {
              return
            }
            const { delivery, total } = props.orderPrices
            if (!delivery.nextTier || props.orderIsPaid) {
              return
            }
            const leftToReachNextTier = delivery.nextTier.threshold - total + delivery.price
            const nextTierDeliveryPrice =
              delivery.nextTier.price > 0
                ? price.format(delivery.nextTier.price)
                : t('orderDeliveryPrice:free')
            return (
              <span className="block text-base text-opaque dark:text-opaqueDark leading-tight">
                {t('orderDeliveryPrice:orderMoreAndDeliveryWillBe', {
                  leftToReachNextTier: price.format(leftToReachNextTier),
                })}{' '}
                {nextTierDeliveryPrice}
              </span>
            )
          })()}
        </div>
        <span className="flex-shrink-0 custom-delivery-price-value">
          {(() => {
            if (props.orderPrices === 'loading' || !props.orderPrices.delivery) {
              return (
                <div className="ml-auto w-7">
                  <Spinner />
                </div>
              )
            }

            if (props.orderPrices.delivery?.priceDependsOnTaxi) {
              return null
            }

            return price.format(props.orderPrices.delivery.price)
          })()}
        </span>
      </div>
      <div className="my-4 border-b border-ghost dark:border-ghostDark">
        {/* horizontal separator */}
      </div>
    </div>
  )
}
